export default __webpack_public_path__ + "static/media/PPD.21f57e51.jpg";